import * as scssStyles from '$CSS/settings.scss';

export const isEncompass = scssStyles.styleEnvironment === 'encompass';
